import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ILimitReloadFormMeta {
    maximumAccountLimit: FormInputMeta;
    reloadMaxValue: FormInputMeta;
    reloadMinValue: FormInputMeta;

}

const limitReloadFormMeta = {} as ILimitReloadFormMeta;

limitReloadFormMeta.maximumAccountLimit = {
    name: "maximumAccountLimit",
    type: "number",
    label: "Maximum Limite de Compte",
    placeholder: "",
    validation: yup.number()
};

limitReloadFormMeta.reloadMaxValue = {
    name: "reloadMaxValue",
    type: "number",
    label: "Maximum Valeur Recharge",
    placeholder: "",
    validation: yup.number()
};

limitReloadFormMeta.reloadMinValue = {
    name: "reloadMinValue",
    type: "number",
    label: "Minimum Valeur Recharge",
    placeholder: "",
    validation: yup.number()
};


export default limitReloadFormMeta;